import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./components/utils/metaPixel";

// Queue the Meta Pixel's init/PageView immediately; the actual ~230 KiB script
// download is deferred internally so it never competes with the LCP image.
initMetaPixel();
function addLink(rel: string, href: string, extra: Partial<HTMLLinkElement> = {}): HTMLLinkElement {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  Object.assign(link, extra);
  document.head.appendChild(link);
  return link;
}

// No manual preconnects here: the platform already preconnects to the
// origins this page actually needs (fonts + our own CDN) before this script
// runs, so adding our own duplicates them and Lighthouse flags them unused.

// Load Google Fonts without blocking the initial render: fetch the stylesheet
// as a low-priority preload, then flip it to an active stylesheet once ready.
// `display=swap` in the URL keeps text visible in a fallback font while it loads.
// This keeps the font request off the critical rendering path entirely.
const fontsHref = "https://fonts.googleapis.com/css2?family=Oswald:wght@600;700&family=Inter:wght@400;500;600;700&display=swap";
const fontPreload = addLink("preload", fontsHref, {
  as: "style"
});
fontPreload.onload = () => {
  fontPreload.onload = null;
  fontPreload.rel = "stylesheet";
};
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-339" data-mp="1oey1g868yz9g" />);
}